import React from 'react';
import { TIMESHEET_GROUP_BY_OPTIONS_ENUM } from '@ubeya/shared/constants';

const PartialNameAggregateRenderer = ({ rowData, columnData: { groupBy, showOnlyFirstName } }) => {
  if (rowData.summarized) {
    return null;
  }

  if (groupBy !== TIMESHEET_GROUP_BY_OPTIONS_ENUM.EMPLOYEE || !rowData?.subRows || rowData?.subRows?.length === 0) {
    return null;
  }

  const { employee: { firstName, lastName } = {} } = rowData.subRows[0];

  return <div>{showOnlyFirstName ? firstName : lastName}</div>;
};

export default PartialNameAggregateRenderer;
